import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal-target',{attrs:{"name":"alerts"}}),(_vm.$user)?_c(VApp,{style:([_vm.baseStyles])},[_c('app-menu'),_c('portal-target',{attrs:{"name":"root"}}),_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }